<template>
    <div class="panel panel-offset" >
        <div class="panel-heading green-bg">
            <h3 class="panel-title">{{evaluationTitle}}</h3>
        </div>
        <div class="panel-body">
            <div v-if="canContribute && adminFormEnabled">
                <div v-bind:class="{ 'has-error': errors.has('isContributing') }">
                    <div class="form-group">
                        <label class="col-md-3 control-label">Contributing Status</label>
                        <div class="col-md-3">
                            <select name="isContributing" class="form-control" v-model="evaluation.isContributing" v-validate="'required'">
                                <option value="" disabled>Select a value</option>
                                <option value=true>Contributing</option>
                                <option value=false>Not Contributing</option>
                                <option value=null>Unevaluated</option>
                            </select>
                            <span v-show="errors.has('isContributing')" class="has-error">Contrib Status is required</span>
                        </div>
                    </div>
                    <div class="form-group" v-if="evaluation.evaluationSourceId === 4" v-bind:class="{ 'has-error': errors.has('concurred') }">
                        <label class="col-md-3 control-label">Source</label>
                        <div class="col-md-3">
                            <select name="concurred" v-model="evaluation.concurredId" class="form-control" v-validate="'required'">
                                <option disabled value ="">Select a value</option>
                                <option v-for="concurredType in concurredList" v-bind:value="concurredType.concurredId" :key="concurredType.concurredId">
                                    {{concurredType.description}}
                                </option>
                            </select>
                            <span v-show="errors.has('concurred')" class="has-error">Concurred is required</span>
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <button class="col-md-2 btn btn-primary" v-on:click="saveEligibility()">Save Evaluation</button>
                </div>
            </div>
            <div v-if="canContribute && !adminFormEnabled">
                <div class="form-group">
                    <label class="col-md-3 control-label">Contributing Status:</label>
                    <div class="col-md-3">
                        <span class="form-control">{{ evaluation.isContributing === 'null' || evaluation.isContributing === '' ?
                            'Unevaluated' : ( evaluation.isContributing ? 'Contributing' : 'Not Contributing' ) }}</span>
                    </div>
                </div>
                <div v-bind:class="{ 'has-error': errors.has('isContributing') }">
                    <div class="form-group" v-if="evaluation.evaluationSourceId === 4" v-bind:class="{ 'has-error': errors.has('concurred') }">
                        <label class="col-md-3 control-label">Source:</label>
                        <div class="col-md-3">
                            <span class="form-control">{{concurredDescription}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="!canContribute">
                Head of Segment is ineligibile.
            </div>
        </div>
    </div>
</template>

<script>
import loggingService from '@/services/util/loggingService'
import evaluationService from '@/services/siteForm/evaluationService'
import validationResultDisplay from '@/components/ValidationResultDisplay.vue'
//import roleService from '@/services/roleService.js'
import { mapState } from 'vuex'

export default {
    name: 'segmentEvaluationForm',
    components: {
        validationResultDisplay
    },
    data: function () {
        return {
            isLoading: false,
            isDebug: false,
            eligibilityTypeList: [],
            effectList: [],
            evaluation: {},
            isKeeper: false,
            disabledStyle: {
                'pointer-type': 'None',
                'opacity': 0.4
            },
            validationResult: [],
            concurredList: evaluationService.ConcurredList,
            sourceSubmitStatus: {
            },
            headList: []
        }
    },
    props: {
        segmentHead: {},
        culturalResourceId: { default: null },
        segHeadEval: {},
        adminFormEnabled: { default: false },
        crr: {}
    },
    mounted () {
        this.log(`SegmentEvaluation mounted`)
    },
    computed: {
        canContribute: function () {
            return !!this.segHeadEval && this.segHeadEval.eligibilityId === evaluationService.EligibilityEnum.Eligible
        },
        evaluationTitle: function () {
            return ((this.segmentHead) ? 'Contributing Status to ' + this.segmentHead.siteName : '')
        },
        // compute current user info
        ...mapState({
            shpoUserDto: state => state.auth.shpoUserDto
        }),
        concurredDescription: function () {
            return (this.concurredList.find(f => f.concurredId === this.evaluation.concurredId) || { description: '' }).description
        }
    },
    methods: {
        log (message) {
            loggingService.log(this.isDebug, 'Site Evaluation', message)
        },
        isEligible (evaluationSourceId) {
            var evaluation = this.evaluation.find(x => { return x.evaluationSourceId === evaluationSourceId })
            return evaluation.eligibilityId === evaluationService.EligibilityEnum.Eligible
        },
        loadEvaluations (crrId) {
            return evaluationService.currentEligibility(this.$http, this.culturalResourceId).then(response => {
                if (response.data) {
                    this.evaluation = response.data
                    this.evaluation.sourceName = evaluationService.sourceName(this.evaluation.evaluationSourceId)
                    //hack to property handle null value with vue-validate
                    if (this.evaluation.isContributing === null) this.evaluation.isContributing = 'null'
                } else {
                    this.log('creating new evaluation')
                    // create evaluation
                    this.createEvaluation(evaluationService.EvaluationSourceEnum.Current)
                }
                return response
            })
        },
        createEvaluation (evaluationSourceId) {
            var evaluationDto = {
                culturalResourceRecordingId: this.crr,
                isContributing: '',
                eligibilityId: '',
                effectId: '',
                evaluationSourceId: evaluationSourceId,
                associatedCulturalResourceId: this.segmentHead ? this.segmentHead.culturalResourceId : null,
                sourceName: evaluationService.sourceName(evaluationSourceId),
                justification: ''
            }
            if (this.canContribute) {
                this.log('found contributor, copy stuff from head')
                evaluationDto.eligibilityId = this.segHeadEval.eligibilityId
                evaluationDto.isEligibleA = this.segHeadEval.isEligibleA
                evaluationDto.isEligibleB = this.segHeadEval.isEligibleB
                evaluationDto.isEligibleC = this.segHeadEval.isEligibleC
                evaluationDto.isEligibleD = this.segHeadEval.isEligibleD
            }
            this.evaluation = evaluationDto
        },
        loadData () {
            var crrId = this.$route.params.culturalResourceRecordingId
            this.log(`Loading data. CR: ${this.culturalResourceId}`)
            // load current workflowstatus first so its data can be used in latter calls
            return Promise.all([this.loadEvaluations(crrId)]).then(response2 => {
                this.loadLookups()
            })
        },
        loadLookups () {
            this.eligibilityTypeList = evaluationService.EligibilityTypeList
            this.effectList = evaluationService.EffectList
        },
        saveEligibility () {
            this.$validator.validateAll().then(result => {
                if (result) {
                    this.log('Save eligibility has been called for ' + this.evaluation.sourceName)
                    if (this.evaluation.isContributing === 'null') {
                        this.evaluation.isContributing = null
                    } else if (this.evaluation.isContributing === 'true') {
                        this.evaluation.isContributing = true
                    } else if (this.evaluation.isContributing === 'false') {
                        this.evaluation.isContributing = false
                    }

                    evaluationService.put(this.$http, this.evaluation).then(result => {
                        if (result.data.isValid) {
                            this.loadData()
                        } else {
                            this.log('evaluation is INVALID, showing errors')
                            this.validationResult = result.data
                        }
                    })
                } else {
                    this.log('submit - invalid form')
                }
            })
        }
    }
}
</script>

<style>
    .inline {
        display: inline;
    }
</style>



// WEBPACK FOOTER //
// segmentEvaluationForm.vue?466d9776